export const HeadingTheme = {
  variants: {
    bigCaption: {
      color: 'brand.cyan',
      fontWeight: 'normal',
      fontSize: '6xl',
      fontStyle: 'italic',
      lineHeight: '110%',
      textAlign: 'center'
    },
    label: {
      color: 'brand.cyan',
      fontSize: 'xs'
    }
  },
  sizes: {
    'lg': {
      fontSize: '28px'
    }
  }
}